import JSONAPIClient from '../JSONAPIClient'

JSONAPIClient.define('bi_question_feedback', {
  question_id: '',
  positive: '',
  text: '',
  created_at: '',
  updated_at: '',
})
